<div [class]="themeClass" fxFill>
  <div id="appWrapper" i18n-dir dir="ltr">
    <div class="main-header">
      <pcp-header>
        <div pcpEndItems>
          <router-outlet name="header-end-items"></router-outlet>
        </div>
        <div pcpStartItems>
          <router-outlet name="header-start-items"></router-outlet>
        </div>
      </pcp-header>
    </div>
    <mat-sidenav-container
      class="main-content"
      [autosize]="true"
      [ngClass]="{ disableBackdrop: overRequested }"
    >
      <mat-sidenav
        #snav
        [disableClose]="overRequested"
        class="mat-elevation-z8"
        [(opened)]="sideMenuService.isOpen"
        [ngStyle.xs]="{ width: '100vw' }"
        [ngStyle]="{ width: 'auto' }"
        [mode]="mobileQuery.matches || overRequested ? 'over' : 'side'"
      >
        <pcp-side-menu (changeTheme)="changeTheme($event)">
          <div pcpStartItems>
            <router-outlet name="sidemenu-start-content"></router-outlet>
          </div>
          <div pcpEndItems>
            <router-outlet name="sidemenu-end-content"></router-outlet>
          </div>
        </pcp-side-menu>
      </mat-sidenav>
      <mat-sidenav-content>
        <div pcpSizeMonitor>
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
    <mat-divider></mat-divider>
    <div class="main-footer">
      <footer class="mat-typography">
        <span
          (click)="appFooterLink ? navigateToAppLink() : ''"
          [ngClass]="{ clickableText: appFooterLink }"
          >{{ appFooterText ? appFooterText : appShortName }}</span
        >
        &copy;
        {{ currentYear }}
      </footer>
    </div>
  </div>
</div>
